import React, { useState } from 'react';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Switch, TimePicker } from 'antd';
import moment from 'moment';
import { createShift } from '../../../service/shiftService';
import PropTypes from "prop-types";
import Swal from 'sweetalert2';

dayjs.extend(customParseFormat);

const AddShift = ({ onShiftAdded }) => {
    const [shiftName, setShiftName] = useState('');
    const [lateGracePeriod, setLateGracePeriod] = useState('');
    const [status, statusIsChecked] = useState(false);
    const [isFlexibleShift, setIsFlexibleShift] = useState(false);
    const [ignoreLate, setIgnoreLate] = useState(false);
    const [ignoreLeave, setIgnoreLeave] = useState(false);
    const [weekdaysDefinition, setWeekdaysDefinition] = useState([
        { day: 'Monday', checked: false, from: '', to: '', shiftHours: '' },
        { day: 'Tuesday', checked: false, from: '', to: '', shiftHours: '' },
        { day: 'Wednesday', checked: false, from: '', to: '', shiftHours: '' },
        { day: 'Thursday', checked: false, from: '', to: '', shiftHours: '' },
        { day: 'Friday', checked: false, from: '', to: '', shiftHours: '' },
        { day: 'Saturday', checked: false, from: '', to: '', shiftHours: '' },
        { day: 'Sunday', checked: false, from: '', to: '', shiftHours: '' }
    ]);
    const [halfDayDefinition, setHalfDayDefinition] = useState({
        isHalfDay: false,
        firstHalf: { start: '', end: '', shiftHours: '' },
        secondHalf: { start: '', end: '', shiftHours: '' }
    });

    const handleStatusCheckboxChange = (event) => {
        statusIsChecked(event.target.checked);
    };

    const handleSubmit = async () => {
        const shiftData = {
            shiftName,
            isFlexibleShift,
            weekdaysDefinition,
            halfDayDefinition,
            lateGracePeriod,
            status,
            ignoreLate,
            ignoreLeave
        };
        console.log(shiftData);
        try {
            if (shiftName === "") {
                showWarning("Please fill the required fields");
            } else {
                await createShift(shiftData);
                resetForm();
                onShiftAdded();
            }
        } catch (err) {
            console.log(console.error());
        }
    };

    const print = () => {
        console.log('Printing weekdays definition:', weekdaysDefinition);
        console.log('Printing half day definition:', halfDayDefinition);
    };

    const resetForm = () => {
        setShiftName('');
        statusIsChecked(false);
        setLateGracePeriod('');
        setIsFlexibleShift(false);
        setIgnoreLate(false);
        setIgnoreLeave(false);
        setWeekdaysDefinition([
            { day: 'Monday', checked: false, from: '', to: '', shiftHours: '' },
            { day: 'Tuesday', checked: false, from: '', to: '', shiftHours: '' },
            { day: 'Wednesday', checked: false, from: '', to: '', shiftHours: '' },
            { day: 'Thursday', checked: false, from: '', to: '', shiftHours: '' },
            { day: 'Friday', checked: false, from: '', to: '', shiftHours: '' },
            { day: 'Saturday', checked: false, from: '', to: '', shiftHours: '' },
            { day: 'Sunday', checked: false, from: '', to: '', shiftHours: '' }
        ]);
        setHalfDayDefinition({
            isHalfDay: false,
            firstHalf: { start: '', end: '', shiftHours: '' },
            secondHalf: { start: '', end: '', shiftHours: '' }
        });
    };

    const showWarning = (str) => {
        return Swal.fire({
            title: "Error",
            text: str,
            icon: "error",
        });
    };

    const handleDayCheckboxChange = (e, day) => {
        const updatedWeekdays = weekdaysDefinition.map(weekday => {
            if (weekday.day === day.day) {
                return { ...weekday, checked: e };
            }
            return weekday;
        });
        setWeekdaysDefinition(updatedWeekdays);
    };

    const handleTimeChange = (time, day, type) => {
        const updatedWeekdays = weekdaysDefinition.map(weekday => {
            if (weekday.day === day) {
                return { 
                    ...weekday, 
                    [type]: time ? time.format('HH:mm') : ''
                };
            }
            return weekday;
        });
        setWeekdaysDefinition(updatedWeekdays);
    };

    const handleShiftHoursChange = (e, day) => {
        const updatedWeekdays = weekdaysDefinition.map((item) =>
            item.day === day ? { ...item, shiftHours: e.target.value } : item
        );
        setWeekdaysDefinition(updatedWeekdays);
    };

    const handleFlexibleShift = (event) => {
        const isChecked = event.target.checked;
        setIsFlexibleShift(isChecked);
    };

    const handleIgnoreLate = (event) => {
        const isChecked = event.target.checked;
        setIgnoreLate(isChecked);
    };

    const handleIgnoreLeave = (event) => {
        const isChecked = event.target.checked;
        setIgnoreLeave(isChecked);
    };

    const handleHalfDayCheckboxChange = (e) => {
        setHalfDayDefinition({ ...halfDayDefinition, isHalfDay: e });
    };

    const handleHalfDayTimeChange = (time, half, type) => {
        setHalfDayDefinition({
            ...halfDayDefinition,
            [half]: {
                ...halfDayDefinition[half],
                [type]: time ? time.format('HH:mm') : ''
            }
        });
    };

    const handleHalfDayShiftHoursChange = (e, half) => {
        setHalfDayDefinition({
            ...halfDayDefinition,
            [half]: {
                ...halfDayDefinition[half],
                shiftHours: e.target.value
            }
        });
    };

    return (
        <div>
            <div className="modal fade" id="add-units">
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '90%', width: '1200px' }}>
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Add New Shift</h4>
                                    </div>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form>
                                        <ul className="nav nav-pills modal-table-tab" id="pills-tab" role="tablist"></ul>
                                        <div className="tab-content" id="pills-tabContent">
                                            <div className="tab-pane fade show active" id="pills-add-shift-info" role="tabpanel" aria-labelledby="pills-add-shift-info-tab">
                                                <div className="status-toggle modal-status d-flex justify-content-left align-items-center mb-3">
                                                    <span className="status-label" style={{ marginRight: "20px" }}>Flexible Shift</span>
                                                    <input
                                                        type="checkbox"
                                                        id="user3"
                                                        className="check"
                                                        checked={isFlexibleShift}
                                                        onChange={handleFlexibleShift}
                                                    />
                                                    <label htmlFor="user3" className="checktoggle"></label>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="input-blocks">
                                                            <label>Shift Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={shiftName}
                                                                onChange={(e) => setShiftName(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {!isFlexibleShift && (
                                                        <div className="col-lg-6">
                                                            <div className="input-blocks">
                                                                <label>Late Grace Period (Minutes)</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={lateGracePeriod}
                                                                    onChange={(e) => setLateGracePeriod(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {isFlexibleShift && (
                                                        <div className="col-lg-6">
                                                            <div className="input-blocks"></div>
                                                        </div>
                                                    )}
                                                    {isFlexibleShift && (
                                                        <div className="col-lg-6">
                                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center mb-3">
                                                                <span className="status-label">Ignore Late</span>
                                                                <input
                                                                    type="checkbox"
                                                                    id="user8"
                                                                    className="check"
                                                                    checked={ignoreLate}
                                                                    onChange={handleIgnoreLate}
                                                                />
                                                                <label htmlFor="user8" className="checktoggle"></label>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {isFlexibleShift && (
                                                        <div className="col-lg-6">
                                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center mb-3">
                                                                <span className="status-label" style={{ marginRight: "50px" }}>Ignore Leave</span>
                                                                <input
                                                                    type="checkbox"
                                                                    id="user7"
                                                                    className="check"
                                                                    checked={ignoreLeave}
                                                                    onChange={handleIgnoreLeave}
                                                                />
                                                                <label htmlFor="user7" className="checktoggle"></label>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="col-lg-12">
                                                        <div className="modal-table-item">
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                    <h4>Weekdays Definition</h4>
                                                                    <div className="table-responsive no-pagination">
                                                                        <table className="table">
                                                                            <tbody>
                                                                                {weekdaysDefinition.map((value, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>
                                                                                            <Switch
                                                                                                size="small"
                                                                                                onChange={(e) => handleDayCheckboxChange(e, value)}
                                                                                                disabled={value.day === 'Sunday'}
                                                                                                checked={value.checked}
                                                                                            />
                                                                                            <span className="status-label ms-2">{value.day}</span>
                                                                                        </td>
                                                                                        {isFlexibleShift && (
                                                                                            <td style={{display:"none"}}>
                                                                                                <span>
                                                                                                    <label>Shift Hours</label>
                                                                                                    <div className="form-icon">
                                                                                                        <input
                                                                                                            type="number"
                                                                                                            className="form-control"
                                                                                                            value={value.shiftHours}
                                                                                                            onChange={(e) => handleShiftHoursChange(e, value.day)}
                                                                                                            disabled={!value.checked}
                                                                                                        />
                                                                                                    </div>
                                                                                                </span>
                                                                                            </td>
                                                                                        )}
                                                                                        {!isFlexibleShift && (
                                                                                            <td>
                                                                                                <span>
                                                                                                    <label>From</label>
                                                                                                    <div className="form-icon">
                                                                                                        <TimePicker
                                                                                                            popupStyle={{ zIndex: 1070 }}
                                                                                                            className="input-group-text"
                                                                                                            defaultValue={moment('00:00', 'HH:mm')}
                                                                                                            format="HH:mm"
                                                                                                            value={value.from ? moment(value.from, 'HH:mm') : null}
                                                                                                            onChange={(time) => handleTimeChange(time, value.day, 'from')}
                                                                                                            style={{ width: "100%", boxSizing: "border-box" }}
                                                                                                            disabled={!value.checked}
                                                                                                        />
                                                                                                    </div>
                                                                                                </span>
                                                                                            </td>
                                                                                        )}
                                                                                        {!isFlexibleShift && (
                                                                                            <td>
                                                                                                <label>To</label>
                                                                                                <div className="form-icon">
                                                                                                    <TimePicker
                                                                                                        popupStyle={{ zIndex: 1070 }}
                                                                                                        className="input-group-text"
                                                                                                        defaultValue={moment('00:00', 'HH:mm')}
                                                                                                        value={value.to ? moment(value.to, 'HH:mm') : null}
                                                                                                        format="HH:mm"
                                                                                                        onChange={(time) => handleTimeChange(time, value.day, 'to')}
                                                                                                        style={{ width: "100%", boxSizing: "border-box" }}
                                                                                                        disabled={!value.checked}
                                                                                                    />
                                                                                                </div>
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <h4>Half Day Definition</h4>
                                                                    <div className="table-responsive no-pagination">
                                                                        <table className="table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>
                                                                                        <Switch
                                                                                            size="small"
                                                                                            onChange={(e) => handleHalfDayCheckboxChange(e)}
                                                                                            checked={halfDayDefinition.isHalfDay}
                                                                                        />
                                                                                        <span className="status-label ms-2">Enable Half Day</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span>
                                                                                            <label>First Half Start</label>
                                                                                            <div className="form-icon">
                                                                                                <TimePicker
                                                                                                    popupStyle={{ zIndex: 1070 }}
                                                                                                    className="input-group-text"
                                                                                                    defaultValue={moment('00:00', 'HH:mm')}
                                                                                                    format="HH:mm"
                                                                                                    value={halfDayDefinition.firstHalf.start ? moment(halfDayDefinition.firstHalf.start, 'HH:mm') : null}
                                                                                                    onChange={(time) => handleHalfDayTimeChange(time, 'firstHalf', 'start')}
                                                                                                    style={{ width: "100%", boxSizing: "border-box" }}
                                                                                                    disabled={!halfDayDefinition.isHalfDay}
                                                                                                />
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span>
                                                                                            <label>First Half End</label>
                                                                                            <div className="form-icon">
                                                                                                <TimePicker
                                                                                                    popupStyle={{ zIndex: 1070 }}
                                                                                                    className="input-group-text"
                                                                                                    defaultValue={moment('00:00', 'HH:mm')}
                                                                                                    format="HH:mm"
                                                                                                    value={halfDayDefinition.firstHalf.end ? moment(halfDayDefinition.firstHalf.end, 'HH:mm') : null}
                                                                                                    onChange={(time) => handleHalfDayTimeChange(time, 'firstHalf', 'end')}
                                                                                                    style={{ width: "100%", boxSizing: "border-box" }}
                                                                                                    disabled={!halfDayDefinition.isHalfDay}
                                                                                                />
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td style={{display:"none"}}>
                                                                                        <span>
                                                                                            <label>Shift Hours</label>
                                                                                            <div className="form-icon">
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    value={halfDayDefinition.firstHalf.shiftHours}
                                                                                                    onChange={(e) => handleHalfDayShiftHoursChange(e, 'firstHalf')}
                                                                                                    disabled={!halfDayDefinition.isHalfDay}
                                                                                                />
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td></td>
                                                                                    <td>
                                                                                        <span>
                                                                                            <label>Second Half Start</label>
                                                                                            <div className="form-icon">
                                                                                                <TimePicker
                                                                                                    popupStyle={{ zIndex: 1070 }}
                                                                                                    className="input-group-text"
                                                                                                    defaultValue={moment('00:00', 'HH:mm')}
                                                                                                    format="HH:mm"
                                                                                                    value={halfDayDefinition.secondHalf.start ? moment(halfDayDefinition.secondHalf.start, 'HH:mm') : null}
                                                                                                    onChange={(time) => handleHalfDayTimeChange(time, 'secondHalf', 'start')}
                                                                                                    style={{ width: "100%", boxSizing: "border-box" }}
                                                                                                    disabled={!halfDayDefinition.isHalfDay}
                                                                                                />
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span>
                                                                                            <label>Second Half End</label>
                                                                                            <div className="form-icon">
                                                                                                <TimePicker
                                                                                                    popupStyle={{ zIndex: 1070 }}
                                                                                                    className="input-group-text"
                                                                                                    defaultValue={moment('00:00', 'HH:mm')}
                                                                                                    format="HH:mm"
                                                                                                    value={halfDayDefinition.secondHalf.end ? moment(halfDayDefinition.secondHalf.end, 'HH:mm') : null}
                                                                                                    onChange={(time) => handleHalfDayTimeChange(time, 'secondHalf', 'end')}
                                                                                                    style={{ width: "100%", boxSizing: "border-box" }}
                                                                                                    disabled={!halfDayDefinition.isHalfDay}
                                                                                                />
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td style={{display:"none"}}>
                                                                                        <span>
                                                                                            <label>Shift Hours</label>
                                                                                            <div className="form-icon">
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    value={halfDayDefinition.secondHalf.shiftHours}
                                                                                                    onChange={(e) => handleHalfDayShiftHoursChange(e, 'secondHalf')}
                                                                                                    disabled={!halfDayDefinition.isHalfDay}
                                                                                                />
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input-blocks m-0">
                                                                <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                                    <span className="status-label">Status</span>
                                                                    <input
                                                                        type="checkbox"
                                                                        id="user6"
                                                                        className="check"
                                                                        defaultChecked="true"
                                                                        checked={status}
                                                                        onChange={handleStatusCheckboxChange}
                                                                    />
                                                                    <label htmlFor="user6" className="checktoggle mb-0" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className="mt-4">
                                            <button type="button" className="btn btn-cancel" data-bs-dismiss="modal" onClick={print}>
                                                Close
                                            </button>
                                            <div>
                                                <button type="button" className="btn btn-reset me-2" onClick={resetForm}>
                                                    Reset
                                                </button>
                                                {(!shiftName) ? (
                                                    <button type="button" className="btn btn-submit" onClick={handleSubmit}>
                                                        Save
                                                    </button>
                                                ) : (
                                                    <button type="button" className="btn btn-submit" onClick={handleSubmit} data-bs-dismiss="modal">
                                                        Save
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddShift.propTypes = {
    onShiftAdded: PropTypes.func.isRequired,
};

export default AddShift;